/**
 * Strona produktu: galeria z miniaturami + lightbox (PhotoSwipe),
 * przyciski ilości, pasek "Do koszyka" na mobile.
 */
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';

const initGallery = () => {
	const gallery = document.querySelector('.js-product-gallery');
	if (!gallery) return;

	const mainLink = gallery.querySelector('.js-product-main');
	const mainImg = gallery.querySelector('.js-product-main-img');
	const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.js-product-thumb'));

	// Zmiana zdjęcia po kliknięciu miniatury
	const show = (thumb) => {
		const d = thumb.dataset;

		mainImg.src = d.large;
		if (d.srcset) mainImg.srcset = d.srcset;
		else mainImg.removeAttribute('srcset');
		mainImg.alt = d.alt;
		mainImg.width = Number(d.width);
		mainImg.height = Number(d.height);

		mainLink.href = d.full;
		mainLink.dataset.index = d.index;

		thumbs.forEach((el) => {
			const active = el === thumb;
			el.classList.toggle('border-red', active);
			el.classList.toggle('border-transparent', !active);
			if (active) el.setAttribute('aria-current', 'true');
			else el.removeAttribute('aria-current');
		});
	};

	thumbs.forEach((thumb) => {
		thumb.addEventListener('click', () => show(thumb));
	});

	// Lightbox ze wszystkimi zdjęciami
	const dataSource = thumbs.map((thumb) => ({
		src: thumb.dataset.full,
		width: Number(thumb.dataset.width),
		height: Number(thumb.dataset.height),
		alt: thumb.dataset.alt,
	}));

	const lightbox = new PhotoSwipeLightbox({
		dataSource,
		pswpModule: () => import('photoswipe'),
		bgOpacity: 0.92,
		wheelToZoom: true,
		closeTitle: 'Zamknij',
		zoomTitle: 'Powiększ',
		arrowPrevTitle: 'Poprzednie zdjęcie',
		arrowNextTitle: 'Następne zdjęcie',
		errorMsg: 'Nie udało się wczytać zdjęcia.',
		indexIndicatorSep: ' / ',
	});
	lightbox.init();

	mainLink.addEventListener('click', (e) => {
		e.preventDefault();
		lightbox.loadAndOpen(Number(mainLink.dataset.index) || 0);
	});
};

const initQuantity = () => {
	document.addEventListener('click', (e) => {
		const btn = e.target.closest('.js-qty-minus, .js-qty-plus');
		if (!btn) return;

		const input = btn.closest('.js-qty').querySelector('.js-qty-input');
		const step = Number(input.step) || 1;
		const min = input.min !== '' ? Number(input.min) : 1;
		const max = input.max !== '' ? Number(input.max) : Infinity;
		const current = Number(input.value) || min;
		const next = btn.classList.contains('js-qty-plus') ? current + step : current - step;

		input.value = Math.min(max, Math.max(min, next));
		input.dispatchEvent(new Event('change', { bubbles: true }));
	});
};

const initStickyBar = () => {
	const bar = document.querySelector('.js-product-sticky');
	const submit = document.querySelector('.js-product-submit');
	if (!bar || !submit || !('IntersectionObserver' in window)) return;

	const observer = new IntersectionObserver(
		(entries) => {
			const entry = entries[0];
			// Pokazujemy pasek dopiero, gdy główny przycisk zniknął ponad ekranem
			const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
			bar.classList.toggle('is-visible', visible);
			bar.inert = !visible;
			bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
		},
		{ threshold: 0 }
	);

	observer.observe(submit);
};

export const initProduct = () => {
	initGallery();
	initQuantity();
	initStickyBar();
};
